import React from 'react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FileText } from 'lucide-react';
import SubmissionsTable from './components/SubmissionsTable';

const Submissions: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleCreateSubmission = () => {
    navigate('/submissions/new');
  };

  return (
    <div className="h-full w-full flex flex-col">
      <div className="flex items-center justify-between px-8 py-5 border-b border-gray-200 bg-white sticky top-0 z-10">
        <h1 className="text-gray-900 flex items-center gap-3">
          <span className="font-semibold text-2xl">{t('submissions.title')}</span>
        </h1>
        <Button
          onClick={handleCreateSubmission}
          className="bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium px-3 py-1.5 rounded-md flex items-center gap-2 transition-colors"
        >
          <FileText className="w-4 h-4" />
          <span>{t('submissions.new')}</span>
        </Button>
      </div>

      <div className="flex-1 min-h-0 overflow-y-auto">
        <SubmissionsTable />
      </div>
    </div>
  );
};

export default Submissions;
